import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

interface DowngradeSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogout: () => void;
  message: string;
}

export const DowngradeSuccessModal: React.FC<DowngradeSuccessModalProps> = ({
  isOpen,
  onClose,
  onLogout,
  message,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-8">
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-green-100 p-4">
              <CheckCircleIcon className="w-16 h-16 text-green-600" />
            </div>
          </div>

          {/* Header */}
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              Plan Changed Successfully! 🎉
            </h3>
            <p className="text-gray-600">
              {message}
            </p>
          </div>

          {/* Info Box */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800 font-medium mb-2">
              ⚠️ Important: Logout Required
            </p>
            <p className="text-sm text-blue-700">
              You will be logged out now so the changes can take effect. Please log back in to access your Starter plan account.
            </p>
          </div>

          {/* Action Button */}
          <button
            onClick={onLogout}
            className="w-full px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-semibold text-lg"
          >
            Log Out and Continue
          </button>

          {/* Footer Note */}
          <p className="text-xs text-gray-500 text-center mt-4">
            Your account has been updated. Logging back in will show your new plan.
          </p>
        </div>
      </div>
    </div>
  );
};
